import React from 'react'
import { OpportunityNewsProps } from '../../../lib/types'
import { OPPORTUNITY_SECTION_IDS } from '../opportunity-detail.utils'

const formatNewsDate = (date?: string | null) => {
  if (!date) {
    return ''
  }

  const parsedDate = new Date(date)
  if (Number.isNaN(parsedDate.getTime())) {
    return date
  }

  return new Intl.DateTimeFormat('en-US', {
    month: 'short',
    day: 'numeric',
    year: 'numeric',
  }).format(parsedDate)
}

const OpportunityDetailNews = ({ opportunityDetails }: OpportunityNewsProps) => {
  const news = opportunityDetails?.news
  const articles =
    news?.articles?.filter(
      (article) => article?.headline || article?.summary || article?.image || article?.articleUrl,
    ) ?? []

  if (!news?.showSection || !articles.length) {
    return null
  }

  const heading = news.heading?.trim() || 'News'

  return (
    <section
      id={OPPORTUNITY_SECTION_IDS.news}
      className='opportunity-overview-panel opportunity-cms-section-card opportunity-news-card'
      data-testid='opportunity-news-section'
    >
      <header className='opportunity-news-header'>
        <h2 className='opportunity-cms-section-title h5-heading'>{heading}</h2>
      </header>

      <section className='opportunity-news-list'>
        {articles.map((article, index) => {
          const publishedDate = formatNewsDate(article.publishedDate)
          const sources = article.sources ?? []

          return (
            <article className='opportunity-news-article' key={`${article.headline}-${index}`}>
              {article.image ? (
                <img
                  className='opportunity-news-article-image'
                  src={article.image}
                  alt={article.headline || 'News article'}
                />
              ) : null}

              <section className='opportunity-news-article-content'>
                {publishedDate ? (
                  <p className='opportunity-news-article-date'>{publishedDate}</p>
                ) : null}

                {article.headline ? (
                  <h3 className='opportunity-news-article-title'>{article.headline}</h3>
                ) : null}

                {article.summary ? (
                  <p className='opportunity-news-article-summary'>{article.summary}</p>
                ) : null}

                {sources.length > 0 ? (
                  <section className='opportunity-news-sources'>
                    {sources.map((source) =>
                      source.sourceUrl ? (
                        <a
                          className='opportunity-news-source'
                          href={source.sourceUrl}
                          key={source.sourceUrl}
                          rel='noreferrer'
                          target='_blank'
                        >
                          {source.sourceName || 'Source'}
                        </a>
                      ) : (
                        <span className='opportunity-news-source' key={source.sourceName}>
                          {source.sourceName}
                        </span>
                      ),
                    )}
                  </section>
                ) : null}

                {article.articleUrl ? (
                  <a
                    className='opportunity-news-read-more'
                    href={article.articleUrl}
                    rel='noreferrer'
                    target='_blank'
                  >
                    Read more
                  </a>
                ) : null}
              </section>
            </article>
          )
        })}
      </section>
    </section>
  )
}

export default OpportunityDetailNews
